import { Vue } from "vue-property-decorator"
import { commonObjectState } from "~/state/object"
import { IObjectState } from "~/state/types"
import { NewRequester } from "~/core/Requester"
import ObjectHelper from "~/utils/ObjectHelper"

interface ILandingPageThemeState {
  landingPageThemeDetail: IObjectState<any>
}

export const prefix = "landingpage/theme"

export const state = (): ILandingPageThemeState => ({
  landingPageThemeDetail: commonObjectState(),
})
export const getters = {
  getDetail: (state: any) => (): any => {
    return state?.shortURLDetail?.data || {}
  },
}

export const mutations = {
  updateDetail: (state: ILandingPageThemeState, data) => {
    Vue.set(state, "landingPageThemeDetail", data)
  },
}

export const actions = {
  getDetail: async ({ commit, state }, data) => {
    const path = `updateDetail`
    try {
      commit(path, ObjectHelper.toLoadingStatus(state.landingPageThemeDetail))
      const response = await NewRequester.get<any>(data.url, { ...data })
      commit(
        path,
        ObjectHelper.toObjSuccessStatus(
          state.landingPageThemeDetail,
          response.data
        )
      )
    } catch (e: any) {
      commit(
        path,
        ObjectHelper.toErrorStatus(
          state.landingPageThemeDetail,
          e.response?.data || e
        )
      )
    }
  },
}
